import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter012() {
  return <KbChapterPage slug="chapter-012" />;
}

(Chapter012 as unknown as { path: string }).path = "/theory-album/012";
